export class CustomRuleGroupApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomRuleGroup() {
    return this.#http.get('/customRuleGroup');
  }

  async createCustomRuleGroup(body) {
    return this.#http.post('/customRuleGroup', body);
  }

  async getCustomRuleGroupById({ id }) {
    return this.#http.get(`/customRuleGroup/${id}`);
  }

  async editCustomRuleGroup(body) {
    return this.#http.put('/customRuleGroup', body);
  }

  async deleteCustomRuleGroup({ id }) {
    return this.#http.delete(`/customRuleGroup/${id}`);
  }

  async createCustomRuleGroupCloneHierarchically(body) {
    return this.#http.post('/customRuleGroup/clone/hierarchically', body);
  }
}
